// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Анимации для карточек чеклистов */

/* Пульсация для активных элементов */
@keyframes GRoDX66_umIRLdfd2fB6 {
    0% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.4);
    }
    70% {
        box-shadow: 0 0 0 10px rgba(24, 144, 255, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
    }
}

/* Плавное появление */
@keyframes Wplc2X8XQnA62QWNzAur {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Анимация загрузки */
@keyframes B6vMsbz3JCPv3SmJhAw7 {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}

/* Bounce эффект для кнопок */
@keyframes oetDABvf6CGazBFHbqfV {
    0%, 20%, 60%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-3px);
    }
    80% {
        transform: translateY(-1px);
    }
}

/* Вращение для иконок */
@keyframes WZtoOPD6nWRec5wNtCTk {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* Классы для применения анимаций */
.Wplc2X8XQnA62QWNzAur {
    animation: Wplc2X8XQnA62QWNzAur 0.4s ease-out;
}

.GRoDX66_umIRLdfd2fB6 {
    animation: GRoDX66_umIRLdfd2fB6 2s infinite;
}

.oetDABvf6CGazBFHbqfV {
    animation: oetDABvf6CGazBFHbqfV 0.6s ease-in-out;
}

.WZtoOPD6nWRec5wNtCTk {
    animation: WZtoOPD6nWRec5wNtCTk 1s linear infinite;
}

.B6vMsbz3JCPv3SmJhAw7 {
    background: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-size: 800px 104px;
    animation: B6vMsbz3JCPv3SmJhAw7 1.5s linear infinite;
}

/* Hover эффекты */
.dDJ_HxgjEIBrFXKDKWKw:hover {
    transform: translateY(-2px);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.cQAcQPJwNm9RlBXpBajl:hover {
    transform: scale(1.05);
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

._Ay0Bi49zon8gZ7t0rJD:hover {
    box-shadow: 0 0 20px rgba(24, 144, 255, 0.3);
    transition: box-shadow 0.3s ease;
}

/* Состояния загрузки */
.Kter0kckwVW7yw0gm8rX {
    position: relative;
    overflow: hidden;
}

.Kter0kckwVW7yw0gm8rX::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.6),
        transparent
    );
    animation: B6vMsbz3JCPv3SmJhAw7 1.5s infinite;
    transform: translateX(-100%);
}

/* Micro interactions */
.WsVARgLfbaZFOTsu4yj5 {
    transition: transform 0.1s ease;
}

.WsVARgLfbaZFOTsu4yj5:active {
    transform: scale(0.95);
}

/* Контекстное меню анимации */
.aTt3d30tOUnW7gjC4Rb1 {
    animation: qcY3pmpI7IDv_z9i_YjU 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes qcY3pmpI7IDv_z9i_YjU {
    from {
        opacity: 0;
        transform: translateY(-3px) scale(0.98);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Успешные действия */
.jHhCLyv_jI2zep1K2Q8g {
    animation: jHhCLyv_jI2zep1K2Q8g 0.6s ease-out;
}

@keyframes jHhCLyv_jI2zep1K2Q8g {
    0% {
        background-color: #f6ffed;
        transform: scale(1);
    }
    50% {
        background-color: #d9f7be;
        transform: scale(1.02);
    }
    100% {
        background-color: #f6ffed;
        transform: scale(1);
    }
}

/* Ошибки */
.Cdhg0RzTe1ZG7vAuCuJt {
    animation: Cdhg0RzTe1ZG7vAuCuJt 0.5s ease-in-out;
}

@keyframes Cdhg0RzTe1ZG7vAuCuJt {
    0%, 100% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-5px);
    }
    75% {
        transform: translateX(5px);
    }
}

/* Плавное появление модального окна */
.ITwny2HUMmIHSPXdgZ0o {
    animation: ITwny2HUMmIHSPXdgZ0o 0.3s ease-out;
}

@keyframes ITwny2HUMmIHSPXdgZ0o {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
} `, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/animations.module.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,qCAAqC;AACrC;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,4CAA4C;IAChD;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,6BAA6B;IACjC;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA,6BAA6B;AAC7B;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,mCAAmC;AACnC;IACI,6CAAiC;AACrC;;AAEA;IACI,2CAA4B;AAChC;;AAEA;IACI,gDAAkC;AACtC;;AAEA;IACI,kDAAoC;AACxC;;AAEA;IACI,yFAAyF;IACzF,4BAA4B;IAC5B,oDAAuC;AAC3C;;AAEA,kBAAkB;AAClB;IACI,2BAA2B;IAC3B,uDAAuD;AAC3D;;AAEA;IACI,sBAAsB;IACtB,uDAAuD;AAC3D;;AAEA;IACI,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP;;;;;KAKC;IACD,6CAAgC;IAChC,4BAA4B;AAChC;;AAEA,uBAAuB;AACvB;IACI,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI,kEAAuD;AAC3D;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,sBAAsB;AACtB;IACI,6CAAqC;AACzC;;AAEA;IACI;QACI,yBAAyB;QACzB,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;IACA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;AACJ;;AAEA,WAAW;AACX;IACI,gDAAsC;AAC1C;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,sCAAsC;AACtC;IACI,6CAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ","sourcesContent":["/* Анимации для карточек чеклистов */\n\n/* Пульсация для активных элементов */\n@keyframes pulse {\n    0% {\n        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.4);\n    }\n    70% {\n        box-shadow: 0 0 0 10px rgba(24, 144, 255, 0);\n    }\n    100% {\n        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);\n    }\n}\n\n/* Плавное появление */\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* Анимация загрузки */\n@keyframes shimmer {\n    0% {\n        background-position: -468px 0;\n    }\n    100% {\n        background-position: 468px 0;\n    }\n}\n\n/* Bounce эффект для кнопок */\n@keyframes bounce {\n    0%, 20%, 60%, 100% {\n        transform: translateY(0);\n    }\n    40% {\n        transform: translateY(-3px);\n    }\n    80% {\n        transform: translateY(-1px);\n    }\n}\n\n/* Вращение для иконок */\n@keyframes rotate {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Классы для применения анимаций */\n.fadeInUp {\n    animation: fadeInUp 0.4s ease-out;\n}\n\n.pulse {\n    animation: pulse 2s infinite;\n}\n\n.bounce {\n    animation: bounce 0.6s ease-in-out;\n}\n\n.rotate {\n    animation: rotate 1s linear infinite;\n}\n\n.shimmer {\n    background: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);\n    background-size: 800px 104px;\n    animation: shimmer 1.5s linear infinite;\n}\n\n/* Hover эффекты */\n.hoverFloat:hover {\n    transform: translateY(-2px);\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hoverScale:hover {\n    transform: scale(1.05);\n    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.hoverGlow:hover {\n    box-shadow: 0 0 20px rgba(24, 144, 255, 0.3);\n    transition: box-shadow 0.3s ease;\n}\n\n/* Состояния загрузки */\n.loading {\n    position: relative;\n    overflow: hidden;\n}\n\n.loading::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(255, 255, 255, 0.6),\n        transparent\n    );\n    animation: shimmer 1.5s infinite;\n    transform: translateX(-100%);\n}\n\n/* Micro interactions */\n.microBounce {\n    transition: transform 0.1s ease;\n}\n\n.microBounce:active {\n    transform: scale(0.95);\n}\n\n/* Контекстное меню анимации */\n.contextMenuSlide {\n    animation: slideDown 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes slideDown {\n    from {\n        opacity: 0;\n        transform: translateY(-3px) scale(0.98);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* Успешные действия */\n.successPulse {\n    animation: successPulse 0.6s ease-out;\n}\n\n@keyframes successPulse {\n    0% {\n        background-color: #f6ffed;\n        transform: scale(1);\n    }\n    50% {\n        background-color: #d9f7be;\n        transform: scale(1.02);\n    }\n    100% {\n        background-color: #f6ffed;\n        transform: scale(1);\n    }\n}\n\n/* Ошибки */\n.errorShake {\n    animation: errorShake 0.5s ease-in-out;\n}\n\n@keyframes errorShake {\n    0%, 100% {\n        transform: translateX(0);\n    }\n    25% {\n        transform: translateX(-5px);\n    }\n    75% {\n        transform: translateX(5px);\n    }\n}\n\n/* Плавное появление модального окна */\n.modalFade {\n    animation: modalFade 0.3s ease-out;\n}\n\n@keyframes modalFade {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fadeInUp": `Wplc2X8XQnA62QWNzAur`,
	"pulse": `GRoDX66_umIRLdfd2fB6`,
	"bounce": `oetDABvf6CGazBFHbqfV`,
	"rotate": `WZtoOPD6nWRec5wNtCTk`,
	"shimmer": `B6vMsbz3JCPv3SmJhAw7`,
	"hoverFloat": `dDJ_HxgjEIBrFXKDKWKw`,
	"hoverScale": `cQAcQPJwNm9RlBXpBajl`,
	"hoverGlow": `_Ay0Bi49zon8gZ7t0rJD`,
	"loading": `Kter0kckwVW7yw0gm8rX`,
	"microBounce": `WsVARgLfbaZFOTsu4yj5`,
	"contextMenuSlide": `aTt3d30tOUnW7gjC4Rb1`,
	"slideDown": `qcY3pmpI7IDv_z9i_YjU`,
	"successPulse": `jHhCLyv_jI2zep1K2Q8g`,
	"errorShake": `Cdhg0RzTe1ZG7vAuCuJt`,
	"modalFade": `ITwny2HUMmIHSPXdgZ0o`
};
export default ___CSS_LOADER_EXPORT___;
